import { useMemo } from "react";
import {
  computeSelectedByGroup,
  computeFilteredGroupIds,
  computeItemsFilteredByAllergens,
} from "../utils/optionFilters";

export default function useFilteredOptionGroups(
  stationOptions,
  formValues,
  showAllergenItems = false,
) {
  const { selectedByGroup, filteredGroupIds, filteredGroups, allowedItemIds } =
    useMemo(() => {
      const allergies = (formValues && formValues.allergies) || [];
      const effectiveAllergies = showAllergenItems ? [] : allergies;
      const { filteredOptions, allowedItemIds } =
        computeItemsFilteredByAllergens(stationOptions, effectiveAllergies);

      const sel = computeSelectedByGroup(
        filteredOptions,
        formValues || {},
        allowedItemIds,
      );

      const filteredIds = computeFilteredGroupIds(filteredOptions, sel);

      let groups = filteredOptions || [];
      if (filteredIds && filteredIds.length) {
        groups = (filteredOptions || []).filter((opt) => {
          const raw =
            opt.group?.id ?? opt.group?.group_id ?? opt.group?._id ?? null;
          const gid = raw != null ? Number(raw) : null;
          return gid != null && filteredIds.includes(gid);
        });
      }

      return {
        selectedByGroup: sel,
        filteredGroupIds: filteredIds,
        filteredGroups: groups,
        allowedItemIds,
      };
    }, [stationOptions, JSON.stringify(formValues || {}), showAllergenItems]);

  return { selectedByGroup, filteredGroupIds, filteredGroups, allowedItemIds };
}
